<div class="header">
  <span class="header-title">{{ title | titlecase }}</span>
  @if (buttons) {
    <div class="buttons-container" [style.justify-content]="justyButtons">
      @for (button of buttons; track button) {
        <abc-button
          class="button"
          [class]="button.statfullButton ? (button.active ? 'button-active-status' : 'button-desactive-status') : ''"
          [icon]="button.icon"
          [disabled]="button.disabled ?? false"
          [toolTipContent]="button.toolTipContent"
          (click)="handlebuttonClick(button)"
        ></abc-button>
      }
    </div>
  }
  @if (!hideFilterPanel) {
    <div class="searchBar-container">
      @if (!disableFilterMode) {
        <abc-drop-down-button
          [height]="'36px'"
          class="search-type-dropdown-button"
          [icon]="currentFilterOption?.icon"
          displayExpr="caption"
          [dropDownOptions]="{ width: 180 }"
          [items]="filterOptions"
          keyExpr="searchMode"
          (onItemClick)="filterOptionChanged($event)"
        ></abc-drop-down-button>
      }
      <abc-text-box
        [height]="'36px'"
        [width]="'90%'"
        (onValueChanged)="searchTermChanged($event)"
        [valueChangeEvent]="'keyup'"
        [placeholder]="res.get('searchBar-placeholder')"
        #searchInput
        >
      </abc-text-box>
    </div>
  }
</div>
